import { autoinject } from "aurelia-framework";
import { RequestClientService } from "@rightship-tech/common-ui/services/basic/request-client.service";
import { ConfigService } from "@rightship-tech/common-ui/services/basic/config.service";
import { GetVesselRequest, GetVesselResponse } from "../models/vessel.models";

@autoinject
export class VesselApi {

    private vesselApiUrl: string = `${this.configService.config.urls.rightShipPlatformApiUrl}/api/v1/Vessel`;

    constructor(private requestClient: RequestClientService, private configService: ConfigService){}

    //Get vessel
    public getVessel(request: GetVesselRequest): Promise<GetVesselResponse> {
        return this.requestClient.get(`${this.vesselApiUrl}/GetVessel`, request);
    }

    calculateRiskScore(run: { countOraFail: number, countLowFail: number, countMediumFail: number, countAllLow: number, countAllMedium: number, countHighFail: number, countAllHigh: number }) {
        if (run) {
            if (run.countOraFail >= 1) return {
                nominator: 100,
                denominator: 100,
                result: 100
            };

            const low = 1;
            const medium = (low * run.countAllLow) + 1;
            const high = (medium * run.countAllMedium) + 1;

            const riskScore = (run.countLowFail * low) + (run.countMediumFail * medium) + (run.countHighFail * high);
            const totalRiskScore = (run.countAllLow * low) + (run.countAllMedium * medium) + (run.countAllHigh * high);
            if (totalRiskScore > 0) {
                const result = Number(((riskScore / totalRiskScore) * 100).toFixed(2));
                return {
                    nominator: riskScore,
                    denominator: totalRiskScore,
                    result: result
                };
            }
        }

        return {
            nominator: 0,
            denominator: 0,
            result: 0
        };
    }

    public canVesselBeVetted(vesselId: number): Promise<boolean> {
        return this.requestClient.get<boolean>(`${this.vesselApiUrl}/CanVesselBeVetted/${vesselId}`, {});
    }
}
